export default __webpack_public_path__ + "static/media/wallet.7ef7ec6f.svg";